import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { WebService } from "../../Services/WebService";
import { useDispatch, useSelector } from "react-redux";
import { ActionPermission, PageInfo } from "../PageInfo";
import SnackbarComponent from "../../Services/SnackbarComponent";
import DeleteConfirmAlert from "../../Services/AlertComponent";
import ActionButton from "../../Services/ActionButton";
import StaticListComponent from "../../Services/StaticListComponent";
import TableComponent, { NoRecordTemplate } from "../../Services/TableComponent";
import Button from "react-bootstrap/esm/Button";
import { StandardConst } from "../../Services/StandardConst";
import { statusUpdate as ConfigurationflowStatusUpdate } from "../../Services/ConfigurationFlow";
import { Box, Container, Typography, Stack } from "@mui/material";
import { Form, FormInputDropdown, FormInputText } from '../Form'
import BreadcrumbsComponent from "../../Services/BreadcrumbsComponent";
import Modal from "react-bootstrap/Modal";
import * as yup from "yup";
import { WSSuccessAlert } from "../../Services/WSAlert";

const VehicleCustomFields = () => {

    const MasterPageName = "Manage Vehicle Custom Fields";
    const confirmMessage = MasterPageName + " Deleted successfully";
    const AddButtonText = "New Field";
    const ref = useRef();
    const refSnackbar = useRef();
    PageInfo({ pageTitle: "Manage Vehicle Custom Fields" });
    const dispatch = useDispatch();
    const [customFieldsData, setCustomFieldsData] = useState([]);
    const [permission, SetPermission] = useState({});
    const permissionList = useSelector((s) => s.auth.PermissionList ?? []);
    const companyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});
    const addEditModalRef = useRef();

    useEffect(() => {
        SetPermission({
            ManageAdd: ActionPermission("Vehicle Custom Field - Add"),
            ManageEdit: ActionPermission("Vehicle Custom Field - Edit"),
            ManageDelete: ActionPermission("Vehicle Custom Field - Delete"),
        });
    }, [permissionList]);

    const [bData] = React.useState([
        {
            title: "Vehicle Management",
            hrefLink: "#",
        },
        {
            title: "Manage Vehicle Custom Fields",
            hrefLink: "#",
        },
    ]);

    const fetchVehicleCustomFields = async () => {
        const data = await WebService({
            endPoint: `CommonUtility/fetchAll/vehiclecustomfields?CompanyId=${companyInfo.CompanyId}`,
            dispatch,
        });
        setCustomFieldsData(data.sort((a, b) => a.DisplayOrder - b.DisplayOrder));
        dispatch(ConfigurationflowStatusUpdate());
    };

    const [deletedVehicleCustomFieldLabel, setDeletedVehicleCustomFieldLabel] = useState(null);
    const onDelete = async (VehicleCustomFieldDetail) => {
        const VehicleCustomFieldData = VehicleCustomFieldDetail.split(',');
        const VehicleCustomFieldId = VehicleCustomFieldData[0];
        const VehicleCustomFieldLabel = VehicleCustomFieldData[1];
        setDeletedVehicleCustomFieldLabel(VehicleCustomFieldLabel);

        await WebService({
            endPoint: `CommonUtility/vehiclecustomfields?VehicleCustomFieldId=${VehicleCustomFieldId}`,
            method: "DELETE",
            dispatch,
        });
        refSnackbar.current.setOpenSnackBar();
        await fetchVehicleCustomFields();
    };

    useEffect(() => {
        fetchVehicleCustomFields();
    }, []);

    const fnEdit = async (id) => await addEditModalRef.current.openModal(id || 0);


    const handleFieldsOrdring = async (clickedObj, clickedArrow) => {

        // const customFieldsData = filter(invoiceSettingState?.Details, {
        //   Section: clickedObj.Section,
        // })?.sort((a, b) => a.DisplayOrder - b.DisplayOrder);
    
        const maxOrderNumber = customFieldsData[customFieldsData.length - 1].DisplayOrder;
    
        const minOrderNumber = customFieldsData[0].DisplayOrder;
    
        const checkOrder = clickedArrow == StandardConst.ArrowClicked.Up ? clickedObj.DisplayOrder - 1 : clickedObj.DisplayOrder + 1 ;

        if(checkOrder >= minOrderNumber && checkOrder <= maxOrderNumber){
          const clickedRowIndex = customFieldsData.findIndex(item => 
            item.VehicleCustomFieldId === clickedObj.VehicleCustomFieldId);
    
          const nextUpdateIndex = clickedArrow == StandardConst.ArrowClicked.Up ? clickedRowIndex - 1 : clickedRowIndex + 1;
          const nextUpdatVehicleCustomFieldId = customFieldsData[nextUpdateIndex].VehicleCustomFieldId;
          const nextUpdatedOrderNumber = customFieldsData[nextUpdateIndex].DisplayOrder;
    
          await WebService({
            dispatch,
            endPoint: `Vehicle/UpdateOrdringInVehicleColumnFields`,
            method: "PUT",
            body: {
              ClickedUpdatedVehicleCustomFieldId: clickedObj.VehicleCustomFieldId, 
              ClickedUpdatedOrderNumber: clickedObj.DisplayOrder, 
              NextUpdatedVehicleCustomFieldId: nextUpdatVehicleCustomFieldId, 
              NextUpdatedOrderNumber: nextUpdatedOrderNumber, 
            }
            // body: clickedObj
          }).then((response) => {
            if(response > 0){
                fetchVehicleCustomFields();
            }
          });
        }
    };

    const columns = [
        {
            Text: "Field Label",
            Value: "FieldLabel",
        },
        {
            Text: "Field Name",
            Value: "FieldName",
        },
        {
            Text: "Field Type",
            Value: "FieldType"
        },
        {
            Text: "Field Required",
            Value: "FieldIsRequired",
            render: (dr) => (
                StandardConst.YesOrNo?.find(element => element?.value === dr.FieldIsRequired).text
            )

        },
        {
            Text: "Action",
            cssClass: "text-center td-width-100",
            isVisiable: permission.ManageEdit || permission.ManageDelete,
            render: (dr) => (
                <>
                    <ActionButton
                        onClick={() => fnEdit(dr.VehicleCustomFieldId)}
                        disabled={!permission.ManageEdit}
                        IconName="Edit"
                        IconTooltip={"Edit Custom Field"}
                        id={`btnCustomFieldEdit_${dr.VehicleCustomFieldId}`}
                    />
                    <ActionButton
                        onClick={(e) =>
                            ref.current.confirmAlert(
                                "Delete", //Confirm button text
                                "Are You Sure", // Text if Alert
                                "Do you want to delete " + dr.FieldLabel, // Message of Alert
                                `${dr.VehicleCustomFieldId},${dr.FieldLabel}` // Endpoint to hit for delete
                            )}
                        disabled={!permission.ManageDelete}
                        IconName="Delete"
                        IconTooltip={"Delete custom fields"}
                        id={`btnCustomFieldDelete_${dr.VehicleCustomFieldId}`}
                    />

                    <ActionButton
                        onClick={() => handleFieldsOrdring(dr, StandardConst.ArrowClicked.Up)}
                        // disabled={!permission.ManageEdit}
                        IconName="UpArrow"
                        IconTooltip={"Up Arrow"}
                        id={`UpArrow${dr.VehicleCustomFieldId}`}
                    />

                    <ActionButton
                        onClick={() => handleFieldsOrdring(dr, StandardConst.ArrowClicked.Down)}
                        // disabled={!permission.ManageEdit}
                        IconName="DownArrow"
                        IconTooltip={"Down Arrow"}
                        id={`DownArrow${dr.VehicleCustomFieldId}`}
                    />
                </>
            ),
        },
    ]

    return (
        <>
            <Container fluid className="base-container">
                <Box
                    sx={{
                        width: 1,
                    }}
                >
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="">
                            <h3 className="ms-4 mt-2">{MasterPageName}</h3>
                            <div className="ms-4">
                                <BreadcrumbsComponent bData={bData}></BreadcrumbsComponent>
                            </div>
                        </div>
                    </div>
                </Box>
                <SnackbarComponent ref={refSnackbar} confirmMessage={`Custom Field ${(deletedVehicleCustomFieldLabel!== null) ? deletedVehicleCustomFieldLabel : ""} Deleted successfully`} />
                <DeleteConfirmAlert ref={ref} confirmEvent={(v) => onDelete(v)} />
                <TableComponent
                    columns={columns}
                    noRecordCss="p-0"
                    noRecordFound={
                        <NoRecordTemplate
                            headerValue={StandardConst.VehicleCustomFieldheaderValueNoResults}
                            subHeaderValue={StandardConst.VehicleCustomFieldSubHeader}
                            imageUrl={StandardConst.imageNoRecordsFound}
                            actionButton={
                                <>
                                    {permission.ManageAdd && (
                                        <Button variant="outline-primary" onClick={() => fnEdit(0)} id={`no_record_add_${AddButtonText}`}>
                                            Add {AddButtonText}
                                        </Button>
                                    )}
                                </>
                            }
                        />
                    }
                    data={customFieldsData}
                    isSearchRequired={true}
                    title={AddButtonText}
                    onAddEvent={() => fnEdit()}
                    IsAddButtonVisible={permission?.ManageAdd}
                    allowSerialNo={true}
                />
                <AddEditVehicleCustomField
                    highestNumberOfOrderDisplay={customFieldsData[customFieldsData.length - 1]?.DisplayOrder}
                    callBackEvent={async () => await fetchVehicleCustomFields()}
                    ref={addEditModalRef}
                ></AddEditVehicleCustomField>
            </Container>
        </>
    );
}

const AddEditVehicleCustomField = forwardRef((props, ref) => {

    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const [data, setData] = useState({});
    const companyInfo = useSelector((s) => s.auth.CompanyInfo ?? {});

    useImperativeHandle(ref, () => ({
        openModal: async (id) => {
            if (id > 0) {
                await fetchEditValue(id);
            }
            setShow(true);
        },
    }));

    const fetchEditValue = async (id) => {
        const data = await WebService({
                endPoint: `CommonUtility/Edit/vehiclecustomfields?VehicleCustomFieldId=${id || 0}`,
                dispatch,
            }).then((c) => (c.length > 0 ? c[0] : {}));

        setData(data);
    }

    const handleClose = () => {
        setShow(false);
        setData({});
    }
    const schema = yup
        .object()
        .shape({
            FieldName: yup.string().trim().required(StandardConst.ValidationMessages.RequiredFieldMsg),
            FieldLabel: yup.string().trim().required(StandardConst.ValidationMessages.RequiredFieldMsg),
            FieldType: yup.string().trim().required(StandardConst.ValidationMessages.RequiredFieldMsg),
        })
        .required();

    const onSubmit = async (data) => {
        handleClose();

        data.CompanyId = companyInfo.CompanyId;
        if (data.VehicleCustomFieldId === undefined) {
            data.DisplayOrder = (parseInt(props.highestNumberOfOrderDisplay) + 1);
            await WebService({
                endPoint: "CommonUtility/vehiclecustomfields",
                body: data,
                dispatch,
            }).then(res => {
                WSSuccessAlert("Success", `${data.FieldName} added successfully`)
            });
        } else {
            await WebService({
                endPoint: `CommonUtility/vehiclecustomfields?VehicleCustomFieldId=${data.VehicleCustomFieldId}`,
                method: "PUT",
                body: data,
                dispatch,
            }).then(res => {
                WSSuccessAlert("Success", `${data.FieldName} updated successfully`)
            });
        }
        props.callBackEvent();
    };


    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {(data?.VehicleCustomFieldId || 0) === 0
                        ? "Add Vehicle Custom Field"
                        : "Edit Vehicle Custom Field"}
                </Modal.Title>
            </Modal.Header>
            <Form
                defaultValues={data}
                onSubmit={onSubmit}
                validationSchema={schema}
            >
                <Modal.Body className="p-4">
                    <div className="row">
                        <div className="col-md-12">
                            <FormInputText
                                label="Field Label"
                                name="FieldLabel"
                                type="text"
                                isRequired="true"
                            />
                        </div>
                        <div className="col-md-12">
                            <FormInputText
                                label="Field Name"
                                name="FieldName"
                                type="text"
                                isRequired="true"
                            />
                        </div>
                        <div className="col-md-12 pb-1">
                            <FormInputDropdown
                                label="Field Type"
                                name="FieldType"
                                ddOpt={StandardConst.invoiceFieldType}
                                isRequired="true"
                            />
                        </div>
                        <div className="col-md-12 pb-2">
                            <FormInputDropdown
                                name="FieldIsRequired"
                                ddOpt={StandardConst.YesOrNo}
                                label="Field Is Required"
                            />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        id="btnVehicleCustomFieldSubmit"
                        variant="outline-primary"
                        type="submit"
                    >
                        {" "}
                        {(data?.VehicleCustomFieldId || 0) === 0
                            ? "Submit"
                            : "Save Changes"}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
});

export default VehicleCustomFields;